// Focus on title when page changes
// Used for visually impaired users

export function focusTitle() {
  setTimeout(() => {
    (window.document.getElementById("form-title") || { focus() {} }).focus();
  }, 100);
}



// WEBPACK FOOTER //
// ./src/aria.js